import { createTranslateFn, TranslateFn } from '@wix/answers-lib';

const fallbackLanguage = 'en';

const localTranslationsPendingMovingToBigFile = {
	'widget-ng.contact-external.title': 'Need Some Help?',
	'widget-ng.contact-external.btn': 'Write to us',
	'widget-ng.contact-external.sub.title': 'Tell us about your issue & we’ll get back to you ASAP',
	'widget-ng.contact-mail.title': 'Need Some Help?',
	'widget-ng.contact-mail.btn': 'Email us',
	'widget-ng.contact-mail.sub.title': 'Email us about your issue & we’ll get back to you ASAP',
	'common.contact-form.ticket.submit': 'Submit Ticket',
	'common.contact-form.ticket.cancel': 'Cancel',
	'common.contact-form.ticket.submit-ignore-suggested': 'No, I want to open a ticket',
	'common.contact-form.ticket.issue-resolved': 'Yes, my issue was solved!',
	'common.contact-form.ticket.uploading-msg': 'Uploading...',
	'common.contact-form.ticket.title': 'Subject',
	'common.contact-form.ticket.title.placeholder': 'Enter a subject',
	'common.contact-form.ticket.title.error': 'Title length must be at least 10 characters long.',
	'common.contact-form.ticket.description': 'Description',
	'common.contact-form.ticket.description.placeholder': 'Tell us more...',
	'common.contact-form.ticket.description.error': 'Description length must be at least 10 characters long.',
	'common.contact-form.ticket.suggestions.title': 'Does this help?',
	'common.contact-form.user-info.fullname': 'Your Full name',
	'common.contact-form.user-info.fullname.placeholder': 'Full name',
	'common.contact-form.user-info.fullname.error': 'Full name is mandatory',
	'common.contact-form.user-info.email': 'Your Email',
	'common.contact-form.user-info.email.placeholder': 'Email Address',
	'common.contact-form.user-info.email.error': 'Email Address is mandatory',
	'common.contact-form.user-info.email.error.invalid': 'Invalid Email Address',
	'common.contact-form.user-info.submit': 'Submit Ticket',
	'common.contact-form.user-info.cancel': 'Cancel',
	'common.contact-form.attachments.attach' : 'Attach a file',
	'common.contact-form.attachments.cancel' : 'Cancel',
	'common.contact-form.attachments.max-size' : '(Max file size 5MB)',
	'common.contact-form.attachments.read-error' : 'The file could not be read',
	'common.contact-form.attachments.remove' : 'Remove',
	'common.contact-form.attachments.size-error' : 'The file size exceeds the maximun size allowed',
	'common.contact-form.attachments.type-error' :
		'This file type is not supported. Please use one of the following file types:',
	'common.contact-form.attachments.upload-error' : 'The file upload was not successful',
};

export type Translate = TranslateFn;

const merge = (obj1: any, obj2: any) => {
	return Object.keys(obj1 || {}).concat(Object.keys(obj2 || {})).reduce((prev: any, curr: any) => {
		prev[curr] = obj1[curr] || obj2[curr];
		return prev;
	}, {});
};

export const createClientTranslateFn = (locale: string): TranslateFn => {
	const answersTranslations: any =  (window as any).___answersTranslations;
	const allKeys = answersTranslations || {};
	const keys = allKeys[locale] || allKeys[fallbackLanguage] || {};
	const keysWithLocalKeys = merge(keys, localTranslationsPendingMovingToBigFile);

	return createTranslateFn(keysWithLocalKeys);
};

export const createServerTranslateFn = (strings: any = {}): Translate => {
	const keysWithLocalKeys = merge(strings, localTranslationsPendingMovingToBigFile);
	return createTranslateFn(keysWithLocalKeys);
};
